import React from 'react';
import { useIntl } from 'react-intl';
import { Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { Button } from '../../../components/Button';
import { IPermissions } from '../../../app/permission';

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      display: 'flex',
      gap: 12,
    },
  });
};

interface IScheduleMeetingButtonsProps extends WithStyles<typeof styles> {
  permissions: IPermissions;
  scheduleMeetingBtnClick: () => void;
  instanteMeetingBtnClick: () => void;
}

const ScheduleMeetingButtons: React.FC<IScheduleMeetingButtonsProps> = ({
  classes,
  permissions,
  scheduleMeetingBtnClick,
  instanteMeetingBtnClick,
}: IScheduleMeetingButtonsProps) => {
  const intl = useIntl();
  return (
    <div className={classes.root}>
      {permissions.instantMeeting ? (
        <Button
          id="create-instant-meeting-button"
          label={intl.formatMessage({
            id: 'instant_meeting',
          })}
          variant="outlined"
          onClick={instanteMeetingBtnClick}
        />
      ) : null}
      {permissions.scheduleMeeting ? (
        <Button
          id="schedule-meeting-button"
          label={intl.formatMessage({
            id: 'schedule_meeting',
          })}
          variant="contained"
          onClick={scheduleMeetingBtnClick}
          color="primary"
        />
      ) : null}
    </div>
  );
};

export default withStyles(styles)(ScheduleMeetingButtons);
